import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@appEnv/environment';

@Injectable({
  providedIn: 'root'
})
export class BottlingLineRegisterService {

  constructor(private http: HttpClient) { }
  baseURL = environment.parentUnit;
  devisionUrl = environment.devisionUrl;
  licenseURL = environment.licneseBaseUrl;
  addetails(data): Observable<any> {
    const url = this.baseURL + 'bottlingLineRegistration';
    return this.http.post(url, data);
  }
  search(payload: any): Observable<any> {
  
    const url = this.baseURL + 'bottlingLineRegistration/lazySearch';
    return this.http.post(url, payload);
  }
  searchMainTainRequest(payload: any): Observable<any> {
    
    const url = this.baseURL + 'bottlingLineRegistration/lazySearch';
    return this.http.post(url, payload);
  }
  detail(id: Number): Observable<any> {
    const url = this.baseURL + 'bottlingLineRegistration/' + id;
    return this.http.get(url);
  }
  getdetails(category, licanceNo): Observable<any> {
    const url = this.licenseURL + 'license/category/' + category + '?licenseNumber=' + licanceNo;
    return this.http.get(url);
  }
  getlabledata() {
    const url = this.baseURL + 'breweryStockAvailability/lazySearch';
    return this.http.get(url);
  }
  getapplicationnumbers(data): any {
    const url = this.baseURL + 'generateApplicationNumber?registrationType=' + data.registrationType + '&licenseNumber=' + data.licenseNumber;
    return this.http.post(url, {}).toPromise();
  }
  getById(id): Observable<any> {
    const url = this.baseURL + 'bottlingLineRegistration/' + id;
    return this.http.get(url);
  }
  getstatuscount(entityType?) {
    const url = this.baseURL + 'bottlingLineRegistration/overview/statusCount?entityType=' + entityType;
    return this.http.get(url);
  }
  downloadenavalue(payload) {
    const url = this.baseURL + 'reportReceipt/downloadReceipt'
     return this.http.get(url, { responseType: 'blob', params: payload });
   }
}
